import React from 'react'
import withForm from 'constructicon/with-form'
import form from './form'
import { updatePage } from 'supporticon/api/pages'

import Form from 'constructicon/form'
import InputField from 'constructicon/input-field'
import SuccessMessage from '../SuccessMessage'

class EditPageForm extends React.Component {
  constructor () {
    super()
    this.handleSubmit = this.handleSubmit.bind(this)
    this.state = { status: null }
  }

  handleSubmit (e) {
    e.preventDefault()

    const { form, pageId, user } = this.props

    const preparePageData = data => ({
      authType: user.authType,
      name: data.name,
      story: data.story,
      target: parseInt(data.target),
      token: user.token
    })

    return form
      .submit()
      .then(data =>
        Promise.resolve()
          .then(() => this.setState({ status: 'fetching' }))
          .then(() => preparePageData(data))
          .then(params => updatePage(pageId, params))
          .then(() => this.setState({ status: 'fetched' }))
          .catch(error => {
            this.setState({ status: 'failed' })
            return Promise.reject(error)
          })
      )
  }

  render () {
    const { form } = this.props
    const { status } = this.state

    const errors = status === 'failed'
      ? [{ message: 'There was an error updating your page' }]
      : []

    return (
      <div>
        <Form
          errors={errors}
          icon={false}
          isLoading={status === 'fetching'}
          noValidate
          onSubmit={this.handleSubmit}
          submit='Update'>
          <InputField {...form.fields.name} />
          <InputField {...form.fields.story} />
          <InputField {...form.fields.target} />
        </Form>
        <SuccessMessage visible={status === 'fetched'}>
          Page successfully updated
        </SuccessMessage>
      </div>
    )
  }
}

export default withForm(form)(EditPageForm)
